import { render } from "./header.vue?vue&type=template&id=2a8b60dc"
const script = {}

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__